import { log } from '@logtail/next';

export { log as logger };
